///<reference path="../../../../../../typings/index.d.ts" />
///<reference path="../../../../components/modal/modal.interface.ts"/>
///<reference path="../../../../components/common/identity.service.ts"/>
///<reference path="../../../../components/busy/busy.service.ts"/>
///<reference path="../../../../components/models/meevo.model.custom.ts"/>
///<reference path="../../../../components/common/security.keys.ts"/>
///<reference path="../../../../components/common/security.service.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../../../../components/common/security.parts.ts"/>


module Meevo.Plugins.Reports {

    
    import IReportControl = Meevo.Model.IReportControl;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import SecurityKeys = Meevo.Components.Common.SecurityKeys;
    import IReportControlScope = Meevo.Plugins.Reports.IReportControlScope;
    import securityService = Meevo.Components.Common.ISecurityService;
    import SecurityParts = Meevo.Components.Common.SecurityParts;


    interface IReportScope extends ng.IScope {
    }


    export class MeevoClientReferralTypesComponent implements angular.IComponentController {

        static $inject = [
            '$scope',
            '$translate',
            'meevo.components.common.SecurityService'
            
        ];
        
        public mainModel: object;
        public parameterNames: string[];
        public securityAccess: any;
        public options: IReportControl;
        public scope: IReportControlScope;
        private securityKeys: Meevo.Components.Common.SecurityKeys;
        public isStudentTeacherModuleEnabled: boolean; 

        constructor(
            protected $scope: IReportScope,
            private $translate: angular.translate.ITranslateService,
            protected securityService: Meevo.Components.Common.ISecurityService) {
        }
        
        $onInit() {

            if (this.mainModel['ReferredByAClient'] == null) {
                this.mainModel['ReferredByAClient'] = true;
            }
            if (this.mainModel['ReferredByAnEmployee'] == null) {
                this.mainModel['ReferredByAnEmployee'] = true;
            }
            if (this.mainModel['ReferredByReferralType'] == null) {
                this.mainModel['ReferredByReferralType'] = true;
            }
            if (this.mainModel['ReferredByStudent'] == null) {
                this.mainModel['ReferredByStudent'] = true;
                    this.mainModel['ReferredByTeacher'] = true;
            }
            if (this.mainModel['ReferredByTeacher'] == null) {
                this.mainModel['ReferredByTeacher'] = true;
            }

            this.isStudentTeacherModuleEnabled = false;
            this.securityService.checkModuleAccess(SecurityKeys.DATA_STUDENTTEACHERMODULE + SecurityParts.KEY_PART_READ)
                .then((permission: SecurityAccessEnum) => {
                    if (permission === SecurityAccessEnum.Grant) {
                        this.isStudentTeacherModuleEnabled = true;
                    } else {
                        this.mainModel['ReferredByStudent'] = false;
                        this.mainModel['ReferredByTeacher'] = false;
                    }
                    
                });
        }
        
    }

    angular.module('meevo.plugins.reports')
        .component('meevoClientReferralTypesComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/reports/components/meevo-client-referral-types/meevo-client-referral-types.component.html',
            controller: MeevoClientReferralTypesComponent,
            controllerAs: '$ctrl',
            bindings: {
                mainModel: '<',
                parameterNames: '<',
                securityAccess: '<',
                validationJson: '<',
                options: '<',
                disabled: '=?ngDisabled'
            }
        });
}
